import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { custom } from 'devextreme/ui/dialog';
import { MessageBoxModel } from '../../../base/src/abcMessageBox/abcMessageBox';

@Component({
    selector: '',
    template: ``,
    styleUrls: ['./devexMessageBox.component.scss'],
    standalone: false
})
export class DevExMessageBoxcomponent implements OnInit {
  @Input() messageBox: MessageBoxModel;
  @Output() onButtonClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  openMessageBox() {
    let currentMessageBox = custom({
      title: this.messageBox.title,
      messageHtml: this.messageBox.contentText,
      buttons: this.messageBox.buttons,
    });
    currentMessageBox.show().then((dialogResult) => {
      this.onButtonClick.emit(dialogResult.buttonText);
    });
  }
}
